import React from "react";
import { Box, Divider } from "@material-ui/core";
import { CustomCard } from "../../CustomCard";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const PropertySpecificationComponentSkeleton = ({}) => {
  const styles = useStyles();

  return (
    <CustomCard
      borderRadius="xl"
      boxShadow="xs"
      borderColor="secondary"
      classes={styles.wapperPropretySpecification}
    >
      <Box className={styles.containerTopSection}>
        <Box className={styles.containerHeader}>
          <Skeleton variant="text" width={195} height={28} />
          <Skeleton variant="text" width={64} height={20} />
        </Box>
        <Divider />
      </Box>
      <Box className={styles.containerBody}>
        {[...Array(9)].map((_, index) => (
          <Box key={index} className={styles.rowItem}>
            <Box className={styles.containerTopRow}>
              <Skeleton variant="text" width={89} height={24} />
              <Skeleton
                style={{ borderRadius: "16px" }}
                width="48px"
                height="28px"
                variant="text"
              />
            </Box>
            <Box className={styles.containerBottomRow}>
              <Skeleton variant="text" width={25} height={25} />
              <Skeleton variant="text" width={50} height={24} />
              <Skeleton variant="text" width={10} height={10} />
              <Skeleton variant="text" width={50} height={24} />
            </Box>
          </Box>
        ))}
      </Box>
    </CustomCard>
  );
};

export default PropertySpecificationComponentSkeleton;
